(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fc-home-brands"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fc-stock-brands')) {
    customElements.define('fc-stock-brands', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.config = JSON.parse(this.querySelector('[data-brand-config]').textContent);
        if (!this.config.root.endsWith('/')) this.config.root += '/';
        this.failedLogos = new Set();
        this.logoMetrics = new Map();
        this.viewport = this.querySelector('.fc-brand-viewport');
        this.originals = this.querySelector('[data-brand-originals]');
        this.before = this.querySelector('[data-brand-before]');
        this.after = this.querySelector('[data-brand-after]');
        this.all = this.querySelector('[data-brand-all]');
        this.details = this.querySelector('details');
        this.search = this.querySelector('input');
        this.toggle = this.querySelector('[data-brand-motion]');
        this.controls = this.querySelector('.fc-brand-controls');
        this.events = new AbortController();
        const on = (target, type, handler, options = {}) => target.addEventListener(type, handler, {...options, signal:this.events.signal});
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.reduced.matches;
        this.direction = document.documentElement.dir === 'rtl' ? -1 : 1;
        on(this.reduced, 'change', () => { this.userPaused = this.reduced.matches; this.syncMotion(); });
        on(this.search, 'input', () => this.filter());
        on(this.toggle, 'click', () => { this.userPaused = !this.userPaused; this.syncMotion(); });
        on(this.querySelector('[data-brand-prev]'), 'click', () => this.step(-1));
        on(this.querySelector('[data-brand-next]'), 'click', () => this.step(1));
        on(this.viewport, 'pointerdown', event => this.hold(event));
        on(this.viewport, 'pointermove', event => this.move(event));
        on(window, 'pointerup', event => this.release(event));
        on(window, 'pointercancel', event => this.release(event));
        on(this.viewport, 'lostpointercapture', event => { if (event.target === this.viewport) this.release(event); });
        on(this.viewport, 'touchstart', () => { if (this.viewport.contains(document.activeElement)) document.activeElement.blur(); this.focused = false; this.nativeHeld = true; this.coasting = false; clearTimeout(this.resumeTimer); this.syncMotion(); }, {passive:true});
        const touchEnd = event => { if (!event.touches.length) { this.nativeHeld = false; this.coasting = true; this.resumeAfterScroll(); } };
        on(this.viewport, 'touchend', touchEnd, {passive:true});
        on(this.viewport, 'touchcancel', touchEnd, {passive:true});
        on(this.viewport, 'dragstart', event => event.preventDefault());
        on(this.viewport, 'click', event => { if (performance.now() < this.suppressClickUntil) { event.preventDefault(); event.stopPropagation(); } }, {capture:true});
        on(this.viewport, 'scroll', () => { if (this.coasting) this.resumeAfterScroll(); if (!this.nativeHeld && !this.coasting) this.wrap(); }, {passive:true});
        on(this.viewport, 'scrollend', () => { if (this.coasting && !this.nativeHeld) this.resumeAfterScroll(60); });
        on(this.viewport, 'focusin', () => { this.focused = true; this.syncMotion(); });
        on(this.viewport, 'focusout', () => { queueMicrotask(() => { this.focused = this.viewport.contains(document.activeElement); this.syncMotion(); }); });
        on(this.viewport, 'keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.step(event.key === 'ArrowLeft' ? -1 : 1); } });
        on(document, 'visibilitychange', () => { if (!document.hidden && Date.now() - this.lastFetch > 60000) this.refresh(); if (document.hidden && this.drag) this.release({pointerId:this.drag.id}); this.syncMotion(); });
        this.observer = new IntersectionObserver(entries => { this.onScreen = entries[0].isIntersecting; this.syncMotion(); }, {threshold:0.05});
        this.observer.observe(this);
        this.resize = new ResizeObserver(() => this.measure());
        this.resize.observe(this.viewport);
        this.syncMotion(); this.refresh();
        this.timer = setInterval(() => { if (!document.hidden) this.refresh(); }, 60000);
        this.loadCollections();
      }
      disconnectedCallback() {
        clearInterval(this.timer); clearTimeout(this.resumeTimer); cancelAnimationFrame(this.frame);
        this.events?.abort(); this.controller?.abort(); this.observer?.disconnect(); this.resize?.disconnect();
        this.initialized = false;
      }
      cloneCard(brand) {
        const card = this.card(brand, true); card.tabIndex = -1; return card;
      }
      measure() {
        this.before.hidden = false; this.after.hidden = false;
        this.period = this.originals.getBoundingClientRect().width;
        this.looping = this.period > this.viewport.clientWidth && this.viewport.clientWidth > 0;
        this.before.hidden = !this.looping; this.after.hidden = !this.looping;
        this.controls.hidden = !this.looping;
        if (this.looping && !this.viewport.scrollLeft) this.viewport.scrollLeft = this.period;
        this.syncMotion();
      }
      wrap() {
        if (!this.looping || this.focused) return;
        const x = this.viewport.scrollLeft;
        if (x < this.period * .5) this.viewport.scrollLeft = x + this.period;
        else if (x >= this.period * 2) this.viewport.scrollLeft = x - this.period;
      }
      step(direction) {
        this.viewport.scrollLeft += direction * Math.max(136, this.viewport.clientWidth * .65);
        this.wrap(); this.syncMotion();
      }
      hold(event) {
        if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary) return;
        if (event.pointerType === 'mouse') event.preventDefault();
        if (this.viewport.contains(document.activeElement)) document.activeElement.blur();
        this.focused = false;
        this.drag = {id:event.pointerId, x:event.clientX, y:event.clientY, lastX:event.clientX, moved:false};
        this.syncMotion();
      }
      move(event) {
        if (!this.drag || this.drag.id !== event.pointerId) return;
        const dx = event.clientX - this.drag.x, dy = event.clientY - this.drag.y;
        if (!this.drag.moved && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) {
          this.drag.moved = true; this.viewport.setPointerCapture(event.pointerId); this.viewport.dataset.dragging = 'true';
        }
        if (this.drag.moved) { event.preventDefault(); this.viewport.scrollLeft -= event.clientX - this.drag.lastX; this.drag.lastX = event.clientX; this.wrap(); }
      }
      release(event) {
        if (!this.drag || this.drag.id !== event.pointerId) return;
        const drag = this.drag; this.drag = null;
        if (drag.moved) this.suppressClickUntil = performance.now() + 300;
        if (this.viewport.hasPointerCapture(drag.id)) this.viewport.releasePointerCapture(drag.id);
        delete this.viewport.dataset.dragging; this.syncMotion();
      }
      resumeAfterScroll(delay = 160) {
        clearTimeout(this.resumeTimer);
        this.resumeTimer = setTimeout(() => {
          if (this.nativeHeld) return;
          this.coasting = false; this.wrap(); this.syncMotion();
        }, delay);
      }
      syncMotion() {
        cancelAnimationFrame(this.frame);
        this.toggle?.setAttribute('aria-pressed', String(this.userPaused));
        this.toggle?.setAttribute('aria-label', this.userPaused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
        if (this.toggle) { this.toggle.querySelector('[data-motion-play]').hidden = !this.userPaused; this.toggle.querySelector('[data-motion-pause]').hidden = this.userPaused; }
        this.dataset.moving = 'false';
        if (!this.isConnected || !this.looping || !this.onScreen || document.hidden || this.userPaused || this.drag || this.focused || this.nativeHeld || this.coasting) return;
        this.dataset.moving = 'true'; this.lastFrame = null; this.motionPosition = this.viewport.scrollLeft;
        const tick = now => {
          if (!this.isConnected) return;
          if (this.lastFrame !== null) { this.motionPosition += Math.min(now - this.lastFrame, 50) * .032 * this.direction; this.viewport.scrollLeft = this.motionPosition; }
          this.lastFrame = now; const position = this.viewport.scrollLeft; this.wrap(); this.motionPosition += this.viewport.scrollLeft - position; this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }
      normalize(value) { return String(value || '').normalize('NFKD').toLowerCase().replace(/[^\p{L}\p{N}]/gu, ''); }
      async loadCollections() {
        let next = this.config.next;
        for (let page = 0; next && page < 10 && this.isConnected; page++) {
          try {
            const url = new URL(next, location.origin);
            url.searchParams.set('section_id', this.dataset.section);
            const response = await fetch(url, { signal: AbortSignal.timeout(8000) });
            if (!response.ok) return;
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const config = JSON.parse(doc.querySelector('[data-brand-config]').textContent);
            this.config.collections.push(...config.collections);
            next = config.next;
          } catch { return; }
        }
        if (this.vendors) this.render(this.vendors);
      }
      async refresh() {
        if (this.pending) return;
        this.pending = true; this.lastFetch = Date.now(); this.controller = new AbortController();
        const timeout = setTimeout(() => this.controller.abort(), 10000);
        // New logos arrive from the same publisher as product-page brand stories.
        // Refresh only the data; leave the carousel motion and merchant settings intact.
        void this.refreshRegistry();
        try {
          const url = new URL('/apps/swiftfilter/index/cascade', location.origin);
          url.searchParams.set('shop', this.config.shop);
          const response = await fetch(url, { signal: this.controller.signal, cache: 'no-cache' });
          if (!response.ok) throw new Error('Stock unavailable');
          const data = await response.json();
          if (!Array.isArray(data.vendors) || typeof data.totalMatching !== 'number' || data.error || data.building) throw new Error('Stock incomplete');
          const vendors = [...new Set(data.vendors.filter(vendor => typeof vendor === 'string' && vendor.trim()))];
          const signature = JSON.stringify(vendors);
          if (signature !== this.signature) { this.signature = signature; this.vendors = vendors; this.render(vendors); }
          this.dataset.stockState = 'ready';
        } catch {
          this.dataset.stockState = this.vendors ? 'retained' : 'unavailable';
          if (!this.vendors) { this.viewport.setAttribute('aria-busy', 'false'); this.viewport.hidden = true; }
        } finally { clearTimeout(timeout); this.pending = false; }
      }
      async refreshRegistry() {
        if (this.registryPending) return;
        this.registryPending = true;
        try {
          const url = new URL(location.pathname, location.origin);
          url.searchParams.set('section_id', this.dataset.section);
          const response = await fetch(url, {cache:'no-cache', signal:AbortSignal.timeout(8000)});
          if (!response.ok) return;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = JSON.parse(doc.querySelector('[data-brand-config]').textContent).registry;
          if (next?.managed_by !== 'footcourt-brand-registry-v1' || !Array.isArray(next.logos)) return;
          if (JSON.stringify(next) !== JSON.stringify(this.config.registry)) {
            this.config.registry = next;
            if (this.vendors) this.render(this.vendors);
          }
        } catch { /* Keep the last good registry while its source is unavailable. */ }
        finally { this.registryPending = false; }
      }
      card(brand, deferred = false) {
        const link = document.createElement('a');
        link.className = 'fc-brand-logo'; link.href = brand.link; link.dataset.vendor = brand.vendor; link.setAttribute('aria-label', brand.name);
        link.dataset.search = this.normalize(brand.vendor + ' ' + brand.name + ' ' + (brand.collectionName || ''));
        const art = document.createElement('span'); art.className = 'fc-brand-art';
        const image = document.createElement('img');
        image.alt = ''; image.width = 300; image.height = 150; image.loading = deferred ? 'lazy' : 'eager'; image.decoding = 'async'; image.fetchPriority = brand.priority < 12 ? 'auto' : 'low';
        image.addEventListener('error', () => {
          if (this.failedLogos.has(brand.logo)) return;
          this.failedLogos.add(brand.logo);
          if (this.isConnected && this.vendors) this.render(this.vendors);
        }, {once:true});
        if (brand.metrics) this.fit(art, brand.metrics);
        else image.addEventListener('load', () => this.measureLogo(image.src).then(metrics => { if (metrics) this.fit(art, metrics); }), {once:true});
        const source = new URL(brand.logo, location.origin);
        if (source.hostname.endsWith('shopify.com') || source.hostname === location.hostname) {
          const needed = brand.metrics ? Math.ceil(brand.metrics[0] / brand.metrics[4] * 216 / 40) * 40 : 360;
          if (!source.pathname.endsWith('.svg')) source.searchParams.set('width', Math.min(800, Math.max(240, needed)));
        }
        image.src = source.href;
        art.append(image); link.append(art);
        const label = document.createElement('span'); label.className = 'fc-brand-label'; label.textContent = brand.name; link.append(label);
        return link;
      }
      fit(art, metrics) {
        const [width, height, x, y, markWidth, markHeight] = metrics;
        const target = Math.min(108, 42 * markWidth / markHeight);
        art.style.setProperty('--fc-logo-width', (width / markWidth * target / 112 * 100) + '%');
        art.style.setProperty('--fc-logo-x', (-(x + markWidth / 2) / width * 100) + '%');
        art.style.setProperty('--fc-logo-y', (-(y + markHeight / 2) / height * 100) + '%');
        art.dataset.fitted = 'true';
      }
      measureLogo(url) {
        if (this.logoMetrics.has(url)) return this.logoMetrics.get(url);
        const measured = new Promise(resolve => {
          const image = new Image(); image.crossOrigin = 'anonymous';
          const timer = setTimeout(() => resolve(null), 8000);
          image.onerror = () => { clearTimeout(timer); resolve(null); };
          image.onload = () => {
            clearTimeout(timer);
            try {
              const canvas = document.createElement('canvas');
              const scale = Math.min(1, 300 / Math.max(image.naturalWidth, image.naturalHeight));
              canvas.width = Math.max(1, Math.round(image.naturalWidth * scale)); canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
              const context = canvas.getContext('2d', {willReadFrequently:true}); context.drawImage(image, 0, 0, canvas.width, canvas.height);
              const {data} = context.getImageData(0, 0, canvas.width, canvas.height);
              const darkBackground = data[3] > 200 && data[0] + data[1] + data[2] < 120;
              let left = canvas.width, top = canvas.height, right = -1, bottom = -1;
              for (let y = 0; y < canvas.height; y++) for (let x = 0; x < canvas.width; x++) {
                const i = (y * canvas.width + x) * 4;
                if (data[i+3] < 32) continue;
                const contrast = darkBackground ? Math.max(data[i],data[i+1],data[i+2]) : 255 - Math.min(data[i],data[i+1],data[i+2]);
                if (contrast * data[i+3] / 255 < 35) continue;
                left = Math.min(left,x); top = Math.min(top,y); right = Math.max(right,x); bottom = Math.max(bottom,y);
              }
              resolve(right >= left ? [canvas.width,canvas.height,left,top,right-left+1,bottom-top+1] : null);
            } catch { resolve(null); }
          };
          image.src = url;
        });
        this.logoMetrics.set(url, measured); return measured;
      }
      render(vendors) {
        const normalize = value => this.normalize(value);
        const configured = new Map(this.config.brands.map(brand => [normalize(brand.vendor || brand.name), brand]));
        const excluded = new Set((this.config.exclude || '').split(/[\n,]/).map(normalize));
        const logos = new Map(this.config.logos.map(brand => [normalize(brand.vendor), brand]));
        for (const brand of this.config.registry?.logos || []) logos.set(normalize(brand.vendor), brand);
        const imagePath = url => { try { return new URL(url, location.origin).pathname; } catch { return url; } };
        const collections = new Map();
        this.config.collections.forEach(collection => {
          for (const key of [normalize(collection.name), normalize(collection.handle), normalize(collection.handle.replace(/-\d+$/, ''))]) {
            if (!collections.has(key) || collection.logo) collections.set(key, collection);
          }
        });
        const priority = ['Skechers','Adidas','Reebok','BIRKENSTOCK','Polo','NEW BALANCE','Nike','PUMA','asics','361˚','MICHAEL KORS','ANODYNE'].map(normalize);
        const brands = vendors.map(vendor => {
          const key = normalize(vendor), known = configured.get(key), saved = logos.get(key), collection = collections.get(key) || collections.get(normalize(known?.link?.split('/').pop()));
          const logo = known?.logo || saved?.logo || collection?.logo;
          return {vendor, name: known?.name || saved?.name || vendor, collectionName: collection?.name, logo, metrics:saved && imagePath(logo) === imagePath(saved.logo) ? saved.metrics : null, link: known?.link || (saved?.shop_collection ? this.config.root + 'collections/' + encodeURIComponent(saved.shop_collection) : collection?.link) || this.config.root + 'collections/vendors?q=' + encodeURIComponent(vendor), priority: priority.includes(key) ? priority.indexOf(key) : 100};
        }).filter(brand => !excluded.has(normalize(brand.vendor)) && brand.logo && !this.failedLogos.has(brand.logo)).sort((a,b) => a.priority - b.priority || a.vendor.localeCompare(b.vendor));
        const activeVendor = this.contains(document.activeElement) ? document.activeElement.dataset.vendor : null;
        const previousPosition = this.viewport.scrollLeft;
        this.originals.replaceChildren(...brands.map(brand => this.card(brand)));
        this.before.replaceChildren(...brands.map(brand => this.cloneCard(brand)));
        this.after.replaceChildren(...brands.map(brand => this.cloneCard(brand)));
        this.viewport.setAttribute('aria-busy', 'false'); this.viewport.hidden = !brands.length;
        this.all.replaceChildren(...[...brands].sort((a,b) => a.vendor.localeCompare(b.vendor)).map(brand => this.card(brand, true)));
        this.details.hidden = !brands.length;
        this.querySelector('.fc-brand-count').textContent = '(' + brands.length + ')';
        this.measure();
        if (previousPosition && this.looping) this.viewport.scrollLeft = this.period + previousPosition % this.period;
        if (activeVendor) [...this.originals.children].find(link => link.dataset.vendor === activeVendor)?.focus({preventScroll:true});
        this.filter();
        this.syncMotion();
      }
      filter() {
        const term = this.normalize(this.search.value); let count = 0;
        this.all.querySelectorAll('a').forEach(link => { link.hidden = !link.dataset.search.includes(term); if (!link.hidden) count++; });
        this.querySelector('.fc-brand-empty').hidden = count > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-home-store"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fc-store-visit')) {
    customElements.define('fc-store-visit', class extends HTMLElement {
      connectedCallback() {
        const dialog = this.querySelector('dialog'), video = this.querySelector('video'), toggle = this.querySelector('[data-play-toggle]');
        const update = () => { const paused = video.paused; toggle.setAttribute('aria-label', paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause); toggle.querySelector('[data-play-icon]').hidden = !paused; toggle.querySelector('[data-pause-icon]').hidden = paused; };
        this.querySelectorAll('[data-open-map]').forEach(link => link.addEventListener('click', event => {
          if (!dialog.showModal) return;
          event.preventDefault();
          const map = dialog.querySelector('iframe');
          if (!map.src) map.src = map.dataset.mapSrc;
          dialog.showModal();
        }));
        this.querySelector('[data-close-map]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
        if (!video) return;
        video.setAttribute('playsinline', ''); video.muted = true; toggle.hidden = false;
        video.addEventListener('play', update); video.addEventListener('pause', update);
        toggle.addEventListener('click', () => { this.manuallyPaused = !video.paused; if (video.paused) video.play().catch(() => {}); else video.pause(); });
        this.observer = new IntersectionObserver(entries => { for (const entry of entries) { if (entry.isIntersecting && !this.manuallyPaused && !matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(() => {}); else video.pause(); } }, { threshold: 0.2 });
        this.observer.observe(video);
      }
      disconnectedCallback() { this.observer?.disconnect(); this.querySelector('video')?.pause(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-home-types"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fc-shoe-types')) {
    customElements.define('fc-shoe-types', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.list = this.querySelector('.fc-type-list');
        this.prev = this.querySelector('[data-type-prev]');
        this.next = this.querySelector('[data-type-next]');
        this.expand = this.querySelector('[data-type-expand]');
        this.direction = getComputedStyle(this.list).direction === 'rtl' ? -1 : 1;
        const on = (target, type, handler, options = {}) => target.addEventListener(type, handler, {...options, signal:this.events.signal});
        on(this.prev, 'click', () => this.step(-1));
        on(this.next, 'click', () => this.step(1));
        on(this.list, 'scroll', () => this.update(), {passive:true});
        on(this.expand, 'click', () => {
          const expanded = this.dataset.expanded !== 'true';
          this.dataset.expanded = String(expanded);
          this.expand.setAttribute('aria-expanded', String(expanded));
          this.expand.querySelector('span').textContent = expanded ? this.expand.dataset.labelLess : this.expand.dataset.labelAll;
          if (!expanded) this.scrollIntoView({block:'nearest'});
          this.update();
        });
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.list);
        this.motionObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => entry.target.toggleAttribute('data-animate', entry.isIntersecting));
        }, {threshold:.65});
        this.querySelectorAll('.fc-type-card').forEach(card => this.motionObserver.observe(card));
        this.update();
      }
      disconnectedCallback() { this.events?.abort(); this.events = null; this.observer?.disconnect(); this.motionObserver?.disconnect(); }
      step(direction) {
        this.list.scrollBy({left:direction * this.direction * this.list.clientWidth * .8, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      update() {
        const position = Math.abs(this.list.scrollLeft), overflow = this.list.scrollWidth - this.list.clientWidth;
        this.prev.disabled = position < 3;
        this.next.disabled = position >= overflow - 3;
        this.querySelector('.fc-types-controls').hidden = overflow < 3 && this.dataset.expanded !== 'true';
        this.expand.hidden = this.list.children.length < 9;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
